import {EditorState, NodeSelection} from "prosemirror-state";

export const downloadImage = (state: EditorState): boolean => {
    const imageNode = (state.selection as NodeSelection).node;
    const s3FileName = imageNode.attrs.s3FileName;

    // Get fileProvider from app integration
    const appIntegration = state.schema.cached.app;
    const fileProvider = appIntegration?.appState.userState?.fileProvider;
    
    if (!fileProvider) {
        console.error('File provider not available for image download');
        return true;
    }

    fileProvider.getSignedUrl(s3FileName).then((src: string) => {
        fileProvider.downloadFile(src, s3FileName);
    }).catch((error: any) => {
        console.error('Error getting signed URL for image download:', error);
    });

    return true;
};